import ARadio from './index.vue';

ARadio.install = app => {
  app.component(ARadio.name, ARadio);
};

export default ARadio;
